export default "__VITE_ASSET__kS91RYQ0__"